import { Link as RouterLink } from "react-router-dom";
import { Flex, Link, Text } from "@chakra-ui/react";

const FOOTER_LINKS = [
  { label: "About", to: "/about-us" },
  { label: "Contact", to: "/contact-us" },
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

const LandingFooter = () => (
  <Flex
    as="footer"
    maxW="1240px"
    mx="auto"
    px="24px"
    py="40px"
    borderTop="1px solid rgba(255,255,255,0.08)"
    justify="space-between"
    align="center"
    color="rgba(230,236,245,0.5)"
    fontSize="12px"
    direction={{ base: "column", md: "row" }}
    gap="14px"
  >
    <Text>
      © {new Date().getFullYear()} SpearBI · Spear Management. All rights reserved.
    </Text>
    <Flex gap="18px">
      {FOOTER_LINKS.map((l) => (
        <Link
          key={l.label}
          as={RouterLink}
          to={l.to}
          color="rgba(230,236,245,0.6)"
          _hover={{ color: "white", textDecoration: "none" }}
        >
          {l.label}
        </Link>
      ))}
    </Flex>
  </Flex>
);

export default LandingFooter;
